import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
  Button
} from '@material-ui/core'


import RoleDetailsDialog from './RoleDetailsDialog'
import SecurityRoleRow from './SecurityRoleRow'
import schema from '../../../routes/permissions/schema'
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent'

const useStyles = makeStyles(theme => ({
  createNewButton: {
    margin: '1rem'
  }
}))

const RoleManager = props => {
  const { securityRoles } = useSelector(state => state.data)
  const headers = ['Role', 'Description']
  const classes = useStyles()
  const [creatingNew, setCreatingNew] = useState(false)
  return <>
    <RestrictedComponent permissionCheck={schema.ACCOUNT_SECURITY_GROUPS.CREATE}>
      <Button
        className={classes.createNewButton}
        variant="contained"
        color="primary"
        disabled={creatingNew}
        onClick={() => setCreatingNew(true)}
      >
        Create New
      </Button>
    </RestrictedComponent>
    <Table>
      <TableHead>
        <TableRow>
          {headers.map((header, i) => {
            return <TableCell key={'header' + i}>
              {header}
            </TableCell>
          })}
          <TableCell size="small" padding="none">
            Users
        </TableCell>
          {/* empty cell with padding to cover settings button */}
          <TableCell padding="checkbox" />
        </TableRow>
      </TableHead>
      <TableBody>
        {securityRoles.map((role, i) => {
          return <SecurityRoleRow key={'security row' + i} role={role} />
        })}
      </TableBody>
    </Table>
    {creatingNew ? <RoleDetailsDialog
      role={null}
      onClose={() => setCreatingNew(false)}
    /> : null}
  </>
}

export default RoleManager
